import { createSlice } from "@reduxjs/toolkit";

type GlobalState = {
    entityDetails: EntityDetails;
    infoUser: InfoUser;
    selectedAccount: string;
    allAuthorized: boolean;
    isFoodCourt: boolean;
    selectedEntity: EntityDetails;
    pays: PayItem[];
    franchiseCountries: string[];
    paymentType: number;
};

const initialState: GlobalState = {
    entityDetails: {},
    infoUser: {},
    selectedAccount: "",
    allAuthorized: false,
    isFoodCourt: false,
    selectedEntity: {},
    pays: [],
    franchiseCountries: [],
    paymentType: 0,
};

const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        setEntityDetails: (state, action) => {
            state.entityDetails = action.payload;
        },
        setInfoUser: (state, action) => {
            state.infoUser = action.payload;
        },
        setSelectedAccount: (state, action) => {
            state.selectedAccount = action.payload;
        },

        setAllAuthorized: (state, action) => {
            state.allAuthorized = action.payload;
        },
        setIsFoodCourt: (state, action) => {
            state.isFoodCourt = action.payload;
        },
        setPays: (state, action) => {
            state.pays = action.payload;
        },
        deleteAllUser: () => initialState,
        setSelectedEntity: (state, action) => {
            state.selectedEntity = action.payload;
        },
        setFranchiseCountries: (state, action) => {
            state.franchiseCountries = action.payload;
        },
        setPaymentType: (state, action) => {
            state.paymentType = action.payload;
        },
    },
});

export const {
    setEntityDetails,
    setAllAuthorized,
    deleteAllUser,
    setInfoUser,
    setSelectedAccount,
    setIsFoodCourt,
    setSelectedEntity,
    setPays,
    setFranchiseCountries,
    setPaymentType
} = globalSlice.actions;
export default globalSlice.reducer;
